(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'services/adminUserExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var adminUserExtService = require('./../urls').adminUserExtService;
    module.exports = factory(require('backbone-torso/modules/NestedModel'), adminUserExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, adminUserExtService) {
  'use strict';

  /**
   * Model for admin user information. Uses the adminUserExtService and corresponds to an AdminUserDTO.
   *
   * @class AdminUserModel
   * @extends Torso.NestedModel
   * @constructor
   */
  return TorsoNestedModel.extend({
    idAttribute: 'username',
    urlRoot: adminUserExtService
  });
}));
